"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const Wrapper = styled_components_1.default.div `
  ${({ theme, background = "white", fade }) => (0, styled_components_1.css) `
    ${fade &&
    (0, styled_components_1.css) `
      position: relative;
      margin: 0 -128px;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 128px;
        z-index: 1;
        background: linear-gradient(
          90deg,
          ${background} 0%,
          rgba(255, 255, 255, 0) 100%
        );
      }
      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 128px;
        z-index: 1;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          ${background} 100%
        );
      }
    `}

    [data-simplebar] {
      position: relative;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-start;
    }

    .simplebar-wrapper {
      overflow: hidden;
      width: inherit;
      height: inherit;
      max-width: inherit;
      max-height: inherit;
    }

    .simplebar-mask {
      direction: inherit;
      position: absolute;
      overflow: hidden;
      padding: 0;
      margin: 0;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      width: auto !important;
      height: auto !important;
      z-index: 0;
    }

    .simplebar-offset {
      direction: inherit !important;
      box-sizing: inherit !important;
      resize: none !important;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      padding: 0;
      margin: 0;
      -webkit-overflow-scrolling: touch;
    }

    .simplebar-content-wrapper {
      direction: inherit;
      box-sizing: border-box !important;
      position: relative;
      display: block;
      height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
      width: auto;
      visibility: visible;
      max-width: 100%; /* Not required for horizontal scroll to trigger */
      max-height: 100%; /* Needed for vertical scroll to trigger */
      scrollbar-width: none;
      -ms-overflow-style: none;

      overflow: scroll visible;

      outline-color: ${theme.palette.primary.default};
    }
    .simplebar-content-wrapper:focus {
      outline: none;
    }

    .simplebar-content-wrapper::-webkit-scrollbar,
    .simplebar-hide-scrollbar::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    .simplebar-content:before,
    .simplebar-content:after {
      content: " ";
      display: table;
    }

    .simplebar-placeholder {
      max-height: 100%;
      max-width: 100%;
      width: 100%;
      pointer-events: none;
    }

    .simplebar-height-auto-observer-wrapper {
      box-sizing: inherit !important;
      height: 100%;
      width: 100%;
      max-width: 1px;
      position: relative;
      float: left;
      max-height: 1px;
      overflow: hidden;
      z-index: -1;
      padding: 0;
      margin: 0;
      pointer-events: none;
      flex-grow: inherit;
      flex-shrink: 0;
      flex-basis: 0;
    }

    .simplebar-height-auto-observer {
      box-sizing: inherit;
      display: block;
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      height: 1000%;
      width: 1000%;
      min-height: 1px;
      min-width: 1px;
      overflow: hidden;
      pointer-events: none;
      z-index: -1;
    }

    .simplebar-track {
      z-index: 2;
      position: absolute;
      right: 0;
      bottom: 0;
      pointer-events: none;
      overflow: hidden;

      ${fade &&
    (0, styled_components_1.css) `
        margin: 0 128px;
      `}
    }

    [data-simplebar].simplebar-dragging .simplebar-content {
      pointer-events: none;
      user-select: none;
      -webkit-user-select: none;
    }

    [data-simplebar].simplebar-dragging .simplebar-track {
      pointer-events: all;
    }

    .simplebar-scrollbar {
      position: absolute;
      left: 0;
      right: 0;
      min-height: 10px;
    }

    .simplebar-scrollbar:before {
      position: absolute;
      content: "";
      background: ${theme.palette.background.contrast};
      border-radius: 7px;
      left: 2px;
      right: 2px;
      opacity: 0;
      transition: opacity 0.2s linear;
    }

    .simplebar-scrollbar.simplebar-visible:before {
      /* When hovered, remove all transitions from drag handle */
      opacity: 0.5;
      transition: opacity 0s linear;
    }

    .simplebar-track.simplebar-vertical {
      top: 0;
      width: 11px;
    }

    .simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
      top: 2px;
      bottom: 2px;
    }

    .simplebar-track.simplebar-horizontal {
      left: 0;
      height: 11px;
    }

    .simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
      height: 100%;
      left: 2px;
      right: 2px;
    }

    .simplebar-track.simplebar-horizontal .simplebar-scrollbar {
      right: auto;
      left: 0;
      top: 2px;
      height: 7px;
      min-height: 0;
      min-width: 10px;
      width: auto;
    }

    /* Rtl support */
    [data-simplebar-direction="rtl"] .simplebar-track.simplebar-vertical {
      right: auto;
      left: 0;
    }

    .hs-dummy-scrollbar-size {
      direction: rtl;
      position: fixed;
      opacity: 0;
      visibility: hidden;
      height: 500px;
      width: 500px;
      overflow-y: hidden;
      overflow-x: scroll;
    }

    .simplebar-hide-scrollbar {
      position: fixed;
      left: 0;
      visibility: hidden;
      overflow-y: scroll;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
  `}
`;
exports.default = Wrapper;
//# sourceMappingURL=ScrollAreaWrapper.js.map